import { BasicComponentProps } from '@/typings/generic';
import styled from '@emotion/styled';

const Header = styled.header<BasicComponentProps>`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 100;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	border: 0;
	transition: transform 0.4s ease;
	background-color: ${({ theme }) => theme.colors.primaryNavBackground};

	body:has(.StickyNav--sticky) & {
		transform: translateY(-100%);
	}

	header & {
		position: fixed !important;
	}
`;

export default Header;
